@if (gridConfig) {
    <div class="claim-rules-grid">
        <inavista-grid #customerRulesGrid
            [config]="gridConfig"
            [actionIcons]="actionIcons"
            (actionIconClick)="onActionIconClick($event)"
            (exportRequested)="onExportRequested()" />
    </div>
}
